<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="sponsor-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/1">
        <div class="custom-head-wrap mb-5">
            <h1 class="cms-custom-heading">
                {{data_local.Name}}
            </h1>
        </div>
      </div>
      <!-- Col 1 -->
     <div class="vx-col w-full md:w-1/2 mt-4">
        <vs-input
        class="w-full"
        v-model="data_local.PodiumDetails.Title"
        label="Name of Event/Programme"
        name="Name of Event/Programme" />
      </div>
      <div class="vx-col w-full md:w-1/2 mt-4">
        <vs-input
          class="w-full"
          v-model="data_local.PodiumDetails.KnowMoreLink"
          v-validate="{url: {require_protocol: false }}"
          label="Event Website"
          name="Event Website" />
        <span class="text-danger text-sm"  v-show="errors.has('Event Website')">{{ errors.first('Event Website') }}</span>
       </div>
          <div class="vx-col w-full md:w-1/2 mt-4">
          <vs-textarea
            class="w-full"
            v-model="data_local.PodiumDetails.Description"
            counter="300"
            v-validate="'max:300'"
            label="Event Description"
            name="Event Description" />
          <span class="text-danger text-sm"  v-show="errors.has('Event Description')">{{ errors.first('Event Description') }}</span>
        </div>
        
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class=" mt-2" @click="$router.push('/event/exhibitors')">Back To List</vs-button>
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm" color="success">Save & Exit</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data (Also remvoe eslint-disable)
      // You can get data in "this.data_local"

      /* eslint-enable */
      this.$vs.loading();
      const Id = this.$route.params.exhibitorId
      //alert(Id);
      this.$store.dispatch('exhibitorManagement/updatePodiumDetails', { id: Id, data: this.data_local})
        .then(res => { 
          //alert(res.message) 
          this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Exhibitor",
              text: "Exhibitor updated successfully.",
            });
            this.$vs.loading.close();
            this.$router.push("/event/exhibitors/"); 
        }) 
        .catch(err => {          
          //console.error(err) 
        })
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
